import React from 'react';
import { Switcher } from '@shared/ui/kit';
import styles from './SwitcherLabelRow.module.scss';

export interface SwitcherLabelRowProps {
  label: string;
  isActive: boolean;
  onToggle: () => void;
}

export const SwitcherLabelRow = React.memo<SwitcherLabelRowProps>(({ label, isActive, onToggle }) => (
  <div className={styles.row}>
    <Switcher changeFunction={onToggle} size="small" isActive={isActive} variant="default" />
    <p className={styles.switcherLabel}>{label}</p>
  </div>
));
